import { useState } from "react";
import { api, type TamperResult } from "../../api";
import { Modal } from "../Modal";

// Deck, "Trust gap is abstract → make it tangible: show a record being altered, then show ours can't be."
export function TamperModal({ petId, petName, onClose }: { petId: number; petName: string; onClose: () => void }) {
  const [result, setResult] = useState<TamperResult | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function run() {
    setBusy(true);
    setError(null);
    try {
      setResult(await api.tamperTest(petId));
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal title="Try to alter a sealed record" onClose={onClose}
      footer={<><button className="btn ghost" onClick={onClose}>Close</button><button className="btn danger" onClick={run} disabled={busy}>{busy ? "Attempting…" : result ? "Try again" : "Attempt to rewrite history"}</button></>}>
      <p style={{ fontSize: 13, color: "var(--txt2)", lineHeight: 1.6 }}>
        In a centralized registry anyone holding the database keys can silently rewrite an entry. Here we send real
        <code style={{ fontFamily: "var(--mono)", margin: "0 4px" }}>UPDATE</code>and
        <code style={{ fontFamily: "var(--mono)", margin: "0 4px" }}>DELETE</code>statements for {petName}'s latest visit
        straight to the database and show what it answers.
      </p>
      {error && <div className="err">{error}</div>}
      {result?.attempts.map((a) => (
        <div key={a.label} className={`attempt ${a.blocked ? "ok" : "fail"}`}>
          <code>{a.label}</code>
          {a.blocked ? "🛡 Rejected: " : "⚠ "}{a.message}
        </div>
      ))}
      {result && (
        <div className="seal">
          {result.chainStillValid
            ? "🔗 Chain re-verified after the attempt: every block's hash, link and sealed payload are intact."
            : "⚠ Chain verification failed — see the record chain for the affected block."}
        </div>
      )}
    </Modal>
  );
}
